/* eslint-disable max-len */
import Modal from '@mui/material/Modal';
import FormContainer from 'components/Form/FormContainer';
import useToggle from 'hooks/useToggle';
import { t } from 'i18next';
import React, { useLayoutEffect } from 'react';
/** @jsxImportSource @emotion/react */
import 'twin.macro';
import { handleOverflow } from 'utils/utilities';

export const isNotEmptyObject = (object: object) =>
  Object.keys(object).length > 0;

const RequestData = () => {
  const { handleToggleState, toggleState } = useToggle();

  useLayoutEffect(() => {
    handleOverflow(toggleState.isRequestDataFormVisible);
  }, [toggleState.isRequestDataFormVisible]);

  const handleClose = () => handleToggleState('isRequestDataFormVisible');

  return (
    <div tw="flex gap-[1rem]">
      <a
        href="/Methodology/methodology.html"
        target="_blank"
        tw="text-center sm:hidden text-blue-800 uppercase text-sm rounded-[0.5rem] bg-[rgba(255, 255, 255, 0.45)] py-[1rem] w-[14.563rem] lg:w-[10rem] lg:text-xs border-0 hover:bg-blue-50"
      >
        {t('methodology')}
      </a>
      <button
        onClick={() => handleToggleState('isRequestDataFormVisible')}
        tw="sm:hidden text-blue-800 uppercase text-sm rounded-[0.5rem] bg-[rgba(255, 255, 255, 0.45)] py-[1rem] w-[14.563rem] lg:w-[10rem] lg:text-xs border-0 hover:bg-blue-50"
      >
        {t('request_data')}
      </button>
      <Modal
        open={toggleState.isRequestDataFormVisible}
        onClose={handleClose}
        disableScrollLock
        BackdropProps={{ sx: { backgroundColor: 'rgba(0, 0, 0, 0.2)' } }}
      >
        <div
          tabIndex={-1}
          tw="max-w-[41rem] w-full sm:rounded-none sm:h-full absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] gap-[1rem] text-sm bg-white rounded-[0.5rem] text-center p-[2rem 2.5rem 1.5rem 2.5rem] outline-none"
        >
          <FormContainer handleToggleState={handleToggleState} />
        </div>
      </Modal>
    </div>
  );
};

export default RequestData;
